export default __webpack_public_path__ + "media/images/logo-gdp-2510f4b18433b140eab292f2c761175d.png";